import React, { Fragment, useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import _set from 'lodash/set';
import _get from 'lodash/get';

import TextField from 'material-ui/TextField';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';

import api from 'services';
import { getNormalErrors, showNotification } from 'helpers';

import FUEL_TYPES from 'constants/fuel';

const FuelEntity = ({ data: initialData, getFuelList }) => {
    const [data, setData] = useState(initialData);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        setData(initialData);
    }, [initialData]);

    const handleChange = useCallback((changes = []) => {
        function validateValue(value) {
            if (typeof value !== 'boolean') {
                let dots = 0;
                value = value
                    .replace(/[^\d|\.|-]/, '')
                    .replace(/\./g, () => (dots++ > 0 ? '' : '.'))
                    .replace(/\-/g, (match, str) => (str === 0 ? '-' : ''));
            }
            return value;
        }

        const newData = JSON.parse(JSON.stringify(data));
        const newErrors = {};

        changes.forEach((v) => {
            _set(newData, v.key, parseFloat(validateValue(v.value)));
            if (!v.noError) {
                newErrors[v.key] = v.value && typeof v.value !== 'boolean' && !isNaN(parseFloat(v.value)) ? '' : 'required';
            }
        });

        setData(newData);
        setErrors(prevErrors => ({
            ...prevErrors,
            ...newErrors,
        }));
    }, [data]);

    const save = useCallback(async () => {
        if (
            Object.values(errors).some(error => !!error)
        ) {
            return showNotification('There is an error. Check out inputs', 'error');
        }

        const result = await api.fuel.updateOne(data);

        if (result.status === 200) {
            showNotification('Fuel has been updated');
            getFuelList();
        } else {
            showNotification(getNormalErrors(result).error, 'error');
        }
    }, [data, errors, getFuelList]);

    const { actualFuelPrice = {} } = data;

    return (
        <TableRow style={{ borderBottom: '4px solid rgb(224, 224, 224)' }}>
            <TableRowColumn style={{
                display: 'flex',
                justifyContent: 'flex-start',
                flexDirection: 'column',
                alignItems: 'flex-start',
                flexWrap: 'wrap',
            }}
            >
                <Fragment>
                    <p style={{ whiteSpace: 'pre-wrap' }}>{data.name || 'no name'}</p>
                    <RaisedButton
                        label='Update'
                        primary
                        onClick={save}
                        style={{ margin: '0 10px 0 25px', lineHeight: '25px', height: '25px' }}
                        buttonStyle={{ lineHeight: '25px', height: '25px' }}
                        labelStyle={{ fontSize: '11px' }}
                    />
                </Fragment>
            </TableRowColumn>
            {Object.values(FUEL_TYPES).map((fuelType, index) => (
                <TableRowColumn key={fuelType}>
                    <TextField
                        value={actualFuelPrice[fuelType] || ''}
                        hintText='0'
                        style={{ marginLeft: index > 0 ? '10px' : '0' }}
                        onChange={(e, value) => {
                            handleChange([
                                { key: `actualFuelPrice.${fuelType}`, value },
                                { key: `fuel.${fuelType}`, value },
                            ]);
                        }}
                        type='number'
                        fullWidth
                        errorText={errors[`actualFuelPrice.${fuelType}`] ? 'required' : ''}
                    />
                </TableRowColumn>
            ))}
            <TableRowColumn>
                <Fragment>
                    <p>{moment(actualFuelPrice.date || new Date()).format('DD:MM:YYYY hh:mm')}</p>
                </Fragment>
            </TableRowColumn>
        </TableRow>
    );
};

export default React.memo(FuelEntity);



// WEBPACK FOOTER //
// ./app/components/Fuel/FuelEntity.js